const SAAS_ONBOARDING_STEP = 'saasOnboardingStep';

const steps = [
  'members',
  'depositor',
  'beneficiary',
  'notification-settings',
  'activation-notifications',
  'asset-visibility',
  'storage-settings',
  'agreement-setup',
  'agreement-details',
  'summary',
] as const;

export type IOnboardingStep = (typeof steps)[number];

export const getEscrowOnboardingStep = (saasId: string): IOnboardingStep | null => {
  const step = localStorage.getItem(`${SAAS_ONBOARDING_STEP}-${saasId}`) as IOnboardingStep;

  return steps.includes(step) ? step : null;
};

export const setEscrowOnboardingStep = (saasId: string, step: IOnboardingStep) =>
  localStorage.setItem(`${SAAS_ONBOARDING_STEP}-${saasId}`, step);

export const resetEscrowOnboardingStep = (saasId: string) =>
  localStorage.removeItem(`${SAAS_ONBOARDING_STEP}-${saasId}`);
